import axios from "axios";
import $ from "jquery";

export function fetchAudioData() {
  // let CORS = "https://cors-anywhere.herokuapp.com/";
  // let CORS = "https://thingproxy.freeboard.io/fetch/";
  const MainURL = "http://kuulmistest.tlu.ee/numberCombinations/0/";
  // const URL = `${CORS}${MainURL}`;
  const URL = `${MainURL}`;

  return axios
    .get(URL)
    .then((html) => {
      let combinations = [];
      $(html.data)
        .find("td > a")
        .each(function () {
          const that = $(this);
          if (that.attr("href").endsWith("mp3")) {
            combinations.push(that.attr("href").substring(2, 7));
          }
        });
      return combinations;
    })
    .catch((error) => {
      console.warn(error);
      return null;
    });
}

export function fetchAudioImagesData() {
  // let CORS = "https://cors-anywhere.herokuapp.com/";
  // let CORS = "https://thingproxy.freeboard.io/fetch/";
  const MainURL = "http://kuulmistest.tlu.ee/imageCombinations/0/";
  // const URL = `${CORS}${MainURL}`;
  const URL = `${MainURL}`;

  return axios
    .get(URL)
    .then((html) => {
      let combinations = [];
      $(html.data)
        .find("td > a")
        .each(function () {
          const that = $(this);
          if (that.attr("href").endsWith("wav")) {
            const name = that.attr("href");
            const splitA = name.split("_").pop();
            const splitB = splitA.split(".wav");
            let final = "";
            if (splitB.length) final = splitB[0];
            combinations.push(final);
          }
        });
      return combinations;
    })
    .catch((error) => {
      console.warn(error);
      return null;
    });
}
